module.exports = __webpack_public_path__ + "static/img/card_4_2.1a7ea0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_4_2.png
// module id = c7JO
// module chunks = 0